import * as React from 'react'

const SvgIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || '24'}
    height={props.height || '25'}
    fill='none'
    viewBox='0 0 24 25'
    {...props}
  >
    <path
      fill='#1D1D1F'
      d='M22 20.507a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.507V19.5h18V7.8L12 15 2 6V4.5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zM4.434 5.5 12 12.31l7.566-6.81zM0 15.5h8v2H0zm0-5h5v2H0z'
    ></path>
  </svg>
)

export default SvgIcon
